/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Reaction_FireInputs */

const en_us2_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fire`)
};

const pt_br2_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fogo`)
};

const es_419_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuego`)
};

const pt_pt2_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fogo`)
};

const fr_fr2_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feu`)
};

const de_de2_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feuer`)
};

const it_it2_clubs_reaction_fire = /** @type {(inputs: Clubs_Reaction_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuoco`)
};

/**
* | output |
* | --- |
* | "Fire" |
*
* @param {Clubs_Reaction_FireInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_reaction_fire = /** @type {((inputs?: Clubs_Reaction_FireInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Reaction_FireInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_reaction_fire(inputs)
	if (locale === "es-419") return es_419_clubs_reaction_fire(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_reaction_fire(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_reaction_fire(inputs)
	if (locale === "de-DE") return de_de2_clubs_reaction_fire(inputs)
	if (locale === "it-IT") return it_it2_clubs_reaction_fire(inputs)
	return en_us2_clubs_reaction_fire(inputs)
});
export { clubs_reaction_fire as "clubs.reaction_fire" }